import { Tag } from 'antd';
import moment from 'moment';
import {
  CompanyEldStatus,
  CompanyTransfer,
  eldBrandLabel,
  TransferStatusValue,
} from '../../../../../../API/TT_ELD/companyTransfer';
import { DEFAULT_ELD, STANDARD_ELD } from '../../../../../../Utils/eldTypeLabels';

export const formatDate = (date?: string | null) => (date ? moment(date).format('MM-DD-YYYY HH:mm') : '-');

// company.eldStatus: 'active' needs no badge
const ELD_STATUS_TAG: Partial<Record<CompanyEldStatus, { color: string; label: string }>> = {
  migrating: { color: 'processing', label: 'Transferring' },
  migrated_out: { color: 'volcano', label: 'Transferred out' },
};

export const TransferBadge = ({ eldStatus }: { eldStatus?: CompanyEldStatus | null }) => {
  const tag = eldStatus ? ELD_STATUS_TAG[eldStatus] : undefined;
  return tag ? <Tag color={tag.color}>{tag.label}</Tag> : null;
};

// Transferred-out and transferring companies are read-only in the admin panel
export const isTransferLocked = (eldStatus?: string | null) =>
  eldStatus === 'migrated_out' || eldStatus === 'migrating';

export const TRANSFER_STATUS_TAG: Record<TransferStatusValue, { color: string; label: string }> = {
  running: { color: 'processing', label: 'Running' },
  done: { color: 'success', label: 'Done' },
  partial: { color: 'warning', label: 'Partial' },
  failed: { color: 'error', label: 'Failed' },
};

export const TransferStatusTag = ({ status }: { status: TransferStatusValue }) => {
  const tag = TRANSFER_STATUS_TAG[status] ?? { color: 'default', label: status };
  return <Tag color={tag.color}>{tag.label}</Tag>;
};

export const eldTypeLabel = (legal?: boolean) =>
  legal === undefined ? '' : legal ? STANDARD_ELD : DEFAULT_ELD;

// "Transferred to EVO ELD (Standard ELD) on 10-29-2026 09:06",
// "Transferring to EVO ELD (Standard ELD) since 10-29-2026 09:00"
export const transferSummary = (transfer: CompanyTransfer) => {
  const running = transfer.status === 'running';
  const verb = running ? 'Transferring' : 'Transferred';
  const date = running
    ? `since ${formatDate(transfer.startedAt)}`
    : `on ${formatDate(transfer.finishedAt || transfer.startedAt)}`;
  if (transfer.direction === 'in') return `${verb} from ${eldBrandLabel(transfer.sourceEld)} ${date}`;
  const type = eldTypeLabel(transfer.targetLegal);
  return `${verb} to ${eldBrandLabel(transfer.targetEld)}${type ? ` (${type})` : ''} ${date}`;
};
